// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3d2gE","header":"MergedInvoice_header__qpA3J"};